import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Globe } from "lucide-react";

/**
 * Lightweight currency picker used on Plans and Credits pages.
 * - `value`: current ISO-4217 code (e.g. "USD")
 * - `supported`: [{ code, symbol, name, minor_unit, rate_from_inr }]
 * - `onChange`: called with the new code
 */
export const CurrencySelector = ({ value, supported, onChange, detectedCountry, size = "default" }) => {
  if (!supported || supported.length === 0) return null;

  return (
    <div className="inline-flex items-center gap-2" data-testid="currency-selector-wrapper">
      <Globe className="w-4 h-4 text-gray-500" />
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className={size === "sm" ? "h-8 w-[150px] text-xs" : "h-9 w-[180px] text-sm"}
          data-testid="currency-selector-trigger"
        >
          <SelectValue placeholder="Currency" />
        </SelectTrigger>
        <SelectContent className="max-h-[320px]">
          {supported.map((c) => (
            <SelectItem key={c.code} value={c.code} data-testid={`currency-option-${c.code}`}>
              <span className="font-mono mr-2">{c.symbol}</span>
              <span className="font-semibold">{c.code}</span>
              <span className="text-gray-500 ml-2 text-xs">— {c.name}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {detectedCountry && (
        <span className="text-xs text-gray-400" data-testid="detected-country-label">
          Detected: {detectedCountry}
        </span>
      )}
    </div>
  );
};

export default CurrencySelector;
